export const stockInputFields = [
	{
		idCampo: 'barCode',
		descrip: '',
		label: 'Código barra',
		mascara: '',
		editable: 1,
		visible: 1,
		requerido: 0,
		valid: null
	},
	{
		idCampo: 'number_from',
		descrip: '',
		label: 'Desde',
		mascara: '',
		editable: 1,
		visible: 1,
		requerido: 0,
		valid: null
	},
	{
		idCampo: 'number_quantity',
		descrip: '',
		label: 'Cantidad',
		mascara: '',
		editable: 1,
		visible: 1,
		requerido: 0,
		valid: null
	}
]
